import React from 'react';
import { CheckIcon } from 'lucide-react';
import { rosaryBonus } from '../data/content';
export function RosaryBonus() {
  return <section className="w-full bg-ivory py-14 md:py-24" data-id="element-160" data-mp="1ylzyx4wc3cf2">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-161" data-mp="23drfqnpou3s0">
        <div className="mx-auto grid max-w-4xl items-center gap-8 rounded-3xl bg-cream p-6 ring-1 ring-line md:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] md:gap-12 md:p-10" data-id="element-162" data-mp="23gdxfg6alzny">
          <div className="mx-auto w-full max-w-[16rem] md:max-w-none" data-id="element-163" data-mp="1aqx7cp65auuw">
            <img src={rosaryBonus.image} alt={`Mockup de ${rosaryBonus.title}`} className="h-auto w-full object-contain" loading="lazy" data-id="element-164" data-mp="1fnx429h3ul9c" />
          </div>

          <div className="text-center md:text-left" data-id="element-165" data-mp="1oq6ez0gacgn9">
            <p className="inline-flex rounded-full bg-wine px-3 py-1 text-xs font-bold uppercase tracking-[0.16em] text-white" data-id="element-166" data-mp="2v5h0ismg13z0">
              {rosaryBonus.eyebrow}
            </p>
            <h2 className="mt-4 font-serif text-3xl font-semibold leading-tight text-marian md:text-4xl" data-id="element-167" data-mp="306muetruaxa4">
              {rosaryBonus.title}
            </h2>
            <p className="mt-4 leading-relaxed text-muted md:text-lg" data-id="element-168" data-mp="3eu97dpxdl0g7">{rosaryBonus.text}</p>

            <ul className="mt-6 space-y-2.5 text-left" data-id="element-169" data-mp="39t3bjj8f4x2g">
              {rosaryBonus.points.map(point => <li key={point} className="flex items-start gap-3" data-id="element-170" data-mp="34u8i7nctrq43">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-ivory text-marian ring-1 ring-gold/50" data-id="element-171" data-mp="30tyeyigf3dsx">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-172" data-mp="2w1f07i5zucmj" />
                  </span>
                  <span className="font-medium text-ink" data-id="element-173" data-mp="2r3wqhpk5jtdh">{point}</span>
                </li>)}
            </ul>

            <p className="mt-7 inline-flex rounded-xl border border-gold bg-ivory px-4 py-2 text-xs font-bold uppercase tracking-[0.14em] text-wine" data-id="element-174" data-mp="2m2pk9uxnr28x">
              {rosaryBonus.badge}
            </p>
          </div>
        </div>
      </div>
    </section>;
}